'use es6';

import Immutable from 'immutable';
import { cleanObject } from 'ecosystem-marketplace-core/utils/formatters';
const EMPTY_LIST = Immutable.List();
const defaults = {
  fileType: '',
  // TODO: remove hostTemplateTypes once contentTypes is ungated
  hostTemplateTypes: EMPTY_LIST,
  label: '',
  path: '',
  templateType: '',
  contentTypes: EMPTY_LIST
};

class ThemeContentItem extends Immutable.Record(defaults) {
  constructor(json = {}) {
    const jsonCopy = Object.assign({}, json);

    if (json.hostTemplateTypes) {
      jsonCopy.hostTemplateTypes = Immutable.List(json.hostTemplateTypes);
    }

    super(cleanObject(jsonCopy));
  }

}

export default ThemeContentItem;